import {base} from '../../../models/base';
import { fromJS } from "immutable";

export default {
  namespace: 'payment',
  state: {},
  reducers: Object.assign(
    base,
    {
      init(state){
        return { ...state, initialized:true };
      },
    }
  )
};



// WEBPACK FOOTER //
// ./src/pages/payment/models/payment.js